import type { ComponentType, ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface SectionHeaderProps {
  title: ReactNode;
  icon?: ComponentType<{ className?: string }>;
  /** Override the icon colour (defaults to accent). */
  iconClassName?: string;
  /** Optional count badge after the title. */
  count?: number | string | null;
  description?: ReactNode;
  actions?: ReactNode;
  as?: 'h2' | 'h3' | 'h4';
  className?: string;
}

/** Card / section title row: icon + title (+ count) on the left, actions on the right. */
export const SectionHeader = ({
  title,
  icon: Icon,
  iconClassName,
  count,
  description,
  actions,
  as: Tag = 'h3',
  className,
}: SectionHeaderProps) => (
  <div className={cn('flex items-start justify-between gap-3 mb-3', className)}>
    <div className="min-w-0">
      <div className="flex items-center gap-2 min-w-0">
        {Icon && <Icon className={cn('w-4 h-4 shrink-0 text-accent-300', iconClassName)} />}
        <Tag className="text-sm font-semibold text-white truncate">{title}</Tag>
        {count !== undefined && count !== null && (
          <span className="badge badge-neutral">{count}</span>
        )}
      </div>
      {description && <p className="text-xs text-glass-400 mt-0.5">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </div>
);
